module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/navigation/angle-double-right-7fb2cb299b36c9b34dd4799dd7576895.svg";